import { formatRankDelta } from './leagueDetailFormat'

// The ↑n/↓n movement badge, shared by the sticky bar, the hero rank block and the standings row —
// same shape everywhere, only the BEM base differs (`…__sticky-delta`, `…__hero-delta`,
// `…__row-delta`). No delta and a zero delta both render nothing: "unchanged" is the absence of a
// badge, not a 0.
function DeltaBadge({
  delta,
  baseClass,
}: {
  delta: number | null | undefined
  baseClass: string
}) {
  if (delta == null || delta === 0) return null
  return (
    <span
      className={`${baseClass} ${baseClass}--${delta > 0 ? 'up' : 'down'}`}
    >
      {formatRankDelta(delta)}
    </span>
  )
}

export default DeltaBadge
